import React, {ReactElement} from 'react';

import {UserAvatar} from 'app/components/general/avatars';
import {LazyTooltip} from 'app/components/general/LazyTooltip';
import {SignoffStatusWithButton} from 'app/signoffs/components/SignoffStatusWithButton';
import {gt} from 'app/utils/i18n';

import {
  BasicUserSerializedType,
  SignoffDocumentSerializedType,
} from 'sweet-types';

interface SignoffDocumentSidebarItemProps {
  documentSignoff: SignoffDocumentSerializedType;
  selected: boolean;
  removeUser: (user: BasicUserSerializedType) => void;
  addUser: (user: BasicUserSerializedType) => void;
}

export function SignoffDocumentStatsItem({
  documentSignoff,
  selected,
  removeUser,
  addUser,
}: SignoffDocumentSidebarItemProps): ReactElement {
  const selectedUserChanged = () => {
    if (selected) {
      removeUser(documentSignoff.user);
    } else {
      addUser(documentSignoff.user);
    }
  };

  return (
    <div className="d-flex small clearfix p-2 border-bottom align-items-center">
      <div className="d-flex align-items-center float-left flex-fill">
        <UserAvatar user={documentSignoff.user} small showCard />
        <div className="ml-2">
          {documentSignoff.user != null ? (
            <div>{documentSignoff.user.name}</div>
          ) : (
            <div>{gt('Deleted user')}</div>
          )}
          <SignoffStatusWithButton signoff={documentSignoff} alignment="left" />
        </div>
      </div>
      {documentSignoff.user != null ? (
        <LazyTooltip
          tooltip={gt(
            'Request Sign Off for current version to remind %s',
            documentSignoff.user.name
          )}
          hide={documentSignoff.current_signed_at == null}
        >
          <div>
            <input
              style={
                documentSignoff.current_signed_at != null
                  ? {pointerEvents: 'none'}
                  : undefined
              }
              className="m-1 mr-2"
              disabled={documentSignoff.current_signed_at != null}
              type="checkbox"
              checked={selected}
              onChange={selectedUserChanged}
            />
          </div>
        </LazyTooltip>
      ) : null}
    </div>
  );
}
